import { ICartItemData } from "@interfaces";

// The unit RRP the customer sees on the product/fare, read from the cached
// `product.json.faresprices` (matched by `product_price_details_id`, mirroring
// `getCartItemFareData`). Used only as a last-resort price source when a cart
// item's `availability.*` carries no price (failed/pending availability check).
//
// Kept in its own dependency-free module (only a type import from @interfaces,
// erased at compile time) so consumers — including the CartItemComponent — can
// use it without dragging the whole @api/axios chain into their test bundles.
export const getCartItemFareRRP = (cartItem: ICartItemData): number | null => {
    const fares = cartItem.product?.json?.faresprices;
    if (!fares || fares.length === 0) return null;
    const fare = fares.find(
        (f) =>
            f.productPricesDetailsId?.toString() ===
            cartItem.product_price_details_id?.toString(),
    );
    const rrp = fare?.rrp;
    return typeof rrp === "number" && !Number.isNaN(rrp) ? rrp : null;
};
